module.exports = __webpack_public_path__ + "static/img/viral_01.9aebae94.jpg";